import { FC } from 'react';

import cs from 'classnames';

import AttachmentsComponent from 'components/AttachmentsComponent/AttachmentsComponent';

import { Attachment } from 'types/commons';

import { JobseekerAttachmentTypes } from 'constants/enums';

import styles from './AttachmentsSidebarSection.module.scss';

interface AttachmentsSidebarSectionProps {
  className?: string;
  name: string;
  placeholder: string;
  attachmentType: JobseekerAttachmentTypes;
  attachments: Attachment<JobseekerAttachmentTypes>[];
  onChange: () => void;
}

const AttachmentsSidebarSection: FC<AttachmentsSidebarSectionProps> = ({
  className,
  name,
  attachmentType,
  attachments,
  placeholder,
  onChange
}: AttachmentsSidebarSectionProps) => {
  // Removed because of the change of requirements, left for now, for the case of further changes

  // const [labelsForApplicationsResumes, setLabelsForApplicationsResumes] =
  //   useState<LabelForChildId[]>([]);
  // const [isLoading, setIsLoading] = useState<boolean>(false);

  // const bottomLabel = useMemo(() => {
  //   if (attachmentType !== JobseekerAttachmentTypes.CV) {
  //     return null;
  //   }

  //   return (
  //     <Tooltip title="From jobseeker profile" placement="right">
  //       <Tag>Standard Resume</Tag>
  //     </Tooltip>
  //   );
  // }, [attachmentType]);

  // const generatelabels = async (
  //   attachments: Attachment<JobseekerAttachmentTypes>[]
  // ): Promise<void> => {
  //   const resumesForApplications = [...attachments].filter((el) => {
  //     const isApplicationResume = Boolean(el.childId);
  //     return el.type === JobseekerAttachmentTypes.CV && isApplicationResume;
  //   });

  //   if (!resumesForApplications.length) {
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);

  //     const jobsNamesForApplications = await Promise.all(
  //       resumesForApplications.map(async (resume) => {
  //         const application = await applicationsService.getApplicationById(
  //           resume.childId as string
  //         );

  //         return { id: resume.childId, name: application.jobName };
  //       })
  //     );

  //     const labelsForApplicationsResumes = jobsNamesForApplications.map(
  //       (el) => {
  //         return {
  //           id: el.id as string,
  //           label: (
  //             <Tooltip
  //               title={`Application ${el.name} resume`}
  //               placement="right"
  //             >
  //               <Tag>Application resume</Tag>
  //             </Tooltip>
  //           )
  //         };
  //       }
  //     );

  //     setLabelsForApplicationsResumes(labelsForApplicationsResumes);
  //   } catch (e) {
  //     console.error(e);
  //     setLabelsForApplicationsResumes([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   generatelabels(attachments);
  // }, [attachments]);

  return (
    <section className={cs(styles.section, className)}>
      <h2 className={styles.title}>{`${name}(${attachments.length})`}</h2>

      <div className={styles.divider} />

      {!attachments?.length && (
        <div className={styles.placeholder}>{placeholder}</div>
      )}

      {/* {isLoading ? (
        <div>Loading...</div>
      ) : ( */}
      <AttachmentsComponent
        attachmentType={attachmentType}
        attachmentList={attachments}
        onChange={onChange}
        isDeleteDisabled
        isPreviewFile
        // bottomLabel={bottomLabel}
        // bottomLabelsForChildIds={labelsForApplicationsResumes}
      />
      {/* )} */}
    </section>
  );
};

export default AttachmentsSidebarSection;
